export default __webpack_public_path__ + "static/media/embroidery.ca7861a2.JPG";